import EditStakeholderModal from './edit-stakeholder-modal';
export default EditStakeholderModal;
